export default __webpack_public_path__ + "static/ugly-christmas-jumper-0f6d9e4be8ffaac56e2627993af0f622.jpg";